import { render, staticRenderFns } from "./CompanyFormFilesEscalated.vue?vue&type=template&id=61c98e04&scoped=true&"
import script from "./CompanyFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./CompanyFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormFilesEscalated.vue?vue&type=style&index=0&id=61c98e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c98e04",
  null
  
)

export default component.exports